export { AvatarContext as Context } from './avatar-context.js';
export { AvatarFallback as Fallback } from './avatar-fallback.js';
export { AvatarImage as Image } from './avatar-image.js';
export { AvatarRoot as Root } from './avatar-root.js';
export { AvatarRootProvider as RootProvider } from './avatar-root-provider.js';
